import * as yup from "yup";
import { fetchData } from "@utils/api";
import { APIMethods } from "@typeDefinitions";
import {
  PaginationLinks,
  Metadata,
  MetadataSchema,
  PaginationLinksSchema,
} from "@typeDefinitions";
import {
  PatientListNewResource,
  patientListNewResourceSchema,
} from "@client/resources/PatientListNewResource";

export const searchPatientsNew = async (
  params?: URLSearchParams,
): Promise<SearchPatientsNewResponse> => {
  const response = await fetchData(
    "/dietitian/clinic/patients-new",
    APIMethods.GET,
    undefined,
    params,
  );

  return await responseSchema.validate(response);
};

export interface SearchPatientsNewResponse {
  data: PatientListNewResource[];
  links: PaginationLinks;
  meta: Metadata;
}

const responseSchema = yup.object().shape({
  data: yup.array().of(patientListNewResourceSchema.required()).required(),
  links: PaginationLinksSchema.defined(),
  meta: MetadataSchema.defined(),
});
